import { Component } from 'react'

import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  FlatList,
  SafeAreaView,
  Modal,
} from 'react-native'

import { connect } from 'react-redux'
import {
  Collapse,
  CollapseHeader,
  CollapseBody,
} from 'accordion-collapse-react-native'
import { i18n } from '$localization/config.js'

import DefaultNavigationOptions from '$navigation/_components/DefaultNavigationOptions.js'
import LoadingView from '$constants/LoadingView.js'
import RelativeGeneTestButton from './relative_gene_test_components/RelativeGeneTestButton.js'

import ApiFetchHandler from '$api/ApiFetchHandler.js'
import { getLang } from '$utils/lang_utils.js'

import Proband from '$data_models/Proband'

import { setError } from '$redux/defaults/actions.js'

import { showDefaultAlert } from '$navigation/_utils/NavigationUtils.js'

import global_styles from '$constants/styles/global.styles.js'
import styles from '$screens/personal_details/relative_gene_test/_styles/main.styles.js'

class RelativeNegativeGeneTest extends Component {
  colorSettings = this.props.colorSettings

  currentMemberID = this.props.route.params?.currentMemberID ?? false

  proband = this.props.route.params?.proband ?? new Proband()

  onDismiss = this.props.route.params?.onDismiss ?? ''

  individualScreen = this.props.route.params?.individualScreen ?? false

  finalGenelist = ''

  geneListStorage = []

  storageCount = ''

  localRefs = {}

  tempToken = {
    accessToken: this.proband?.account?.authCredentials?.accessToken,
  }

  memberdetails = {
    proband_id: this.proband.probandID,
    member_id: this.currentMemberID,
  }

  state = {
    toggled: false,
    memberGeneTest: '',
    loadMemberGeneTest: true,
    geneTestList: '',
    loadGeneTestList: true,
    // showLayer1: true,
    showLayer2: '',
    // toggleAfterRender: false,
    // showGeneList: false,
    toggleAfterRender: true,
    showGeneList: true,
    modalVisible: false,
  }

  async componentDidMount() {
    const { selectedLanguage, saveError } = this.props

    const getMemberProfilePayload = {
      path: 'member/get/',
      method: 'post',
      token: this.tempToken.accessToken,
      body: { ...this.memberdetails, lang: selectedLanguage },
      pageDetails: {
        page: 'RelativeNegativeGeneTest.js',
      },
    }

    const getMemberProfileResponse = await ApiFetchHandler(
      getMemberProfilePayload
    )

    if (getMemberProfileResponse.isError) {
      saveError({
        isShown: true,
        status: getMemberProfileResponse.status,
        message: getMemberProfileResponse.error,
      })
      return
    }

    this.setState({
      memberGeneTest: getMemberProfileResponse.member_genetic_testing,
      loadMemberGeneTest: false,
    })

    const getGeneTestingListPayload = {
      path: 'genetic_testing/',
      method: 'get',
      body: {
        params: {
          lang: getLang().toString(),
        },
      },
      pageDetails: {
        page: 'RelativeNegativeGeneTest.js',
      },
    }

    const geneTestingPayload = await ApiFetchHandler(getGeneTestingListPayload)

    if (geneTestingPayload.isError) {
      saveError({
        isShown: true,
        status: geneTestingPayload.status,
        message: geneTestingPayload.error,
      })
      return
    }

    this.setState({ geneTestList: geneTestingPayload, loadGeneTestList: false })
  }

  addToTempStorageOnLoad = () => {
    // add To temp data on Load
    const geneList = this.finalGenelist
    const tempStorage = this.geneListStorage

    const mapGeneTest = this.finalGenelist.map((item) => {
      if (item.result == 'n') {
        return { ...item }
      }
    })

    const filteredmapGeneTest = mapGeneTest.filter((item) => item != null)

    this.geneListStorage = JSON.parse(JSON.stringify(filteredmapGeneTest))
  }

  addToTempList = (data) => {
    // add to temp list
    // a. add data to list

    this.geneListStorage.push(data)

    if (this.geneListStorage.length > 0) {
      this.setState({ toggled: true })
    }
  }

  removeToTempList = (data) => {
    // a. remove data from list
    // b. if list is empty disable next button

    const list = this.geneListStorage
    for (const val in list) {
      if (data.id == list[val].id) {
        list.splice(val, 1)
      }
    }

    if (this.geneListStorage.length <= 0) {
      this.setState({ toggled: false })
    }
  }

  mapMemberGenesToGeneList = (memberGeneTest, geneTestList) => {
    // updated gene list
    const newList = geneTestList.map((item) => {
      const returnedData = this.geneTestChecker(item, memberGeneTest)
      return returnedData
    })

    // this.finalGenelist = newList
    const filteredNewList = newList.filter((item) => item != null)

    this.finalGenelist = filteredNewList
  }

  geneTestChecker = (item, memberGeneTest) => {
    if (memberGeneTest.length > 0) {
      for (const val in memberGeneTest) {
        if (memberGeneTest[val].gene_id == item.id) {
          // if (memberGeneTest[val]['result'] == 'n') {
          //   item['result'] = 'n'
          //
          //   return { ...item }
          // } else {
          //   return null
          // }

          return null
        }

        // delete item.result
        // return { ...item }
      }
    }
    return { ...item }
  }

  nextButtonAction = async () => {
    // Add items to API and navigate to next screen
    // a. add each gene test to API
    // b. navigate to next screen or dismiss

    const { navigate } = this.props.navigation

    const { geneListStorage } = this
    const storageLength = geneListStorage.length

    if (geneListStorage?.length > 0) {
      // Toggle-on loading view
      this.setState({ modalVisible: true })

      for (const val in geneListStorage) {
        const addGeneTestToMemberOnboardingPayload = {
          path: `member/${this.memberdetails.member_id}/add_genetic_testing/`,
          method: 'post',
          token: authCredentials.accessToken,
          body: {
            proband_id: this.memberdetails.proband_id,
            gene_id: geneListStorage[val].id,
            result: 'n',
          },
          pageDetails: {
            page: 'RelativeNegativeGeneTest.js',
          },
        }

        const response = await ApiFetchHandler(
          addGeneTestToMemberOnboardingPayload
        )

        const { saveError } = this.props

        if (response.isError) {
          this.setState({ modalVisible: false })

          switch (response.status) {
            case 500:
              showDefaultAlert(
                'Server Error',
                'Sorry we cannot process your request this time.'
              )
              break

            default:
              saveError({
                isShown: true,
                status: response.status,
                message: response.error,
              })
              break
          }
          return
        }

        this.storageCount++

        if (this.storageCount == storageLength) {
          // Toggle-off loading view
          this.setState({ modalVisible: false })

          this.props.navigation.dismiss()
          this.onDismiss()
        }
      }
    } else {
      this.props.navigation.dismiss()
      this.onDismiss()
    }
  }

  renderList = (layerName, refName) => (
    <View style={{ width: '100%' }}>
      <Text
        style={[
          styles.titleText,
          {
            color: this.colorSettings?.text_input_label_color_2,
          },
        ]}
      >
        {i18n.t('did_this_person_test_negative_for_any_genes').default}
      </Text>

      {/* <RelativeGeneTestToggleButton
          ref={'toggle2'}
          parent={this}
          checkRender={this.state.toggleAfterRender}
          onRenderSelect={showLayer2}
          buttonClass={'showLayer2'} /> */}

      <Collapse style={{ width: '100%' }} isCollapsed>
        <CollapseHeader />

        <CollapseBody>
          <Text
            style={[
              styles.titleText,
              {
                color: this.colorSettings?.text_input_label_color_2,
                fontSize: 18,
              },
            ]}
          >
            {i18n.t('select_all_that_apply').default}
          </Text>

          <View
            style={[
              styles.buttonContainerAdopted,
              {
                flexDirection: 'column',
                marginBottom: 10,
                justifyContent: 'center',
              },
            ]}
          >
            <FlatList
              style={{ width: '100%' }}
              keyExtractor={(item, index) => `${item.id}`}
              data={this.finalGenelist}
              renderItem={({ item }) => (
                <RelativeGeneTestButton
                  colorSettings={this.colorSettings}
                  ref={(ref) => (this.localRefs[`geneTest${item.id}`] = ref)}
                  parent={this}
                  id={item.id}
                  genesAPI={item}
                />
              )}
            />
          </View>
        </CollapseBody>
      </Collapse>
    </View>
  )

  render() {
    const {
      memberGeneTest,
      loadMemberGeneTest,
      geneTestList,
      loadGeneTestList,
      toggleAfterRender,
    } = this.state

    if (!loadMemberGeneTest && !loadGeneTestList) {
      this.mapMemberGenesToGeneList(
        memberGeneTest,
        JSON.parse(JSON.stringify(geneTestList))
      )

      if (!toggleAfterRender) {
        this.addToTempStorageOnLoad()
      }

      return (
        <SafeAreaView
          style={[
            global_styles.container,
            {
              backgroundColor: this.colorSettings?.onboarding_bgcolor,
            },
          ]}
        >
          <ScrollView contentContainerStyle={styles.contentContainer}>
            {this.renderList()}
          </ScrollView>

          <View
            style={{
              width: '100%',
              alignSelf: 'flex-end',
              justifyContent: 'flex-end',
            }}
          >
            <View style={{ height: 60, width: '100%' }}>
              <TouchableOpacity
                // disabled={(!this.state.toggled) ? true : false}
                style={[
                  global_styles.nextButton,
                  {
                    backgroundColor:
                      (this.state.toggled
                        ? this.colorSettings?.bottom_next_btn_enabled
                        : this.colorSettings?.bottom_next_btn_disabled) ||
                      'white',
                    borderColor: this.colorSettings?.bottom_next_btn_enabled,
                  },
                ]}
                onPress={this.nextButtonAction}
              >
                <Text
                  style={[
                    global_styles.nextButtonText,
                    {
                      color: this.colorSettings?.btn_filled_text_1,
                    },
                  ]}
                >
                  {this.state.toggled
                    ? this.individualScreen
                      ? i18n.t('done').title
                      : i18n.t('next').title
                    : i18n.t('skip').title}
                </Text>
              </TouchableOpacity>
            </View>
          </View>

          <Modal
            visible={this.state.modalVisible}
            animationType="none"
            transparent
          >
            <View
              style={{
                flex: 1.0,
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <LoadingView
                backgroundColor={this.colorSettings?.onboarding_bgcolor}
                tintColor={this.colorSettings?.btn_no_fill_text_2}
                textColor={this.colorSettings?.btn_no_fill_text_2}
                visible={this.state.modalVisible}
                message={i18n.t('saving_datanplease_wait').default}
              />
            </View>
          </Modal>
        </SafeAreaView>
      )
    }

    return (
      <SafeAreaView
        style={[
          global_styles.container,
          {
            backgroundColor: this.colorSettings?.onboarding_bgcolor,
          },
        ]}
      >
        <LoadingView
          backgroundColor={this.colorSettings?.onboarding_bgcolor}
          tintColor={this.colorSettings?.btn_no_fill_text_2}
          textColor={this.colorSettings?.btn_no_fill_text_2}
          visible
        />
      </SafeAreaView>
    )
  }
}

function mapGlobalStateToProps(state) {
  const { store } = state
  return {
    appSettings: store.appSettings,
    colorSettings: store.colorSettings,
    selectedLanguage: store.selectedLanguage,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    saveError: (data) => dispatch(setError(data)),
  }
}

export default connect(
  mapGlobalStateToProps,
  mapDispatchToProps
)(RelativeNegativeGeneTest)
